module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/yzRmuv/tc-custom/9780226172354.jpg?1732274355475",
      "alt": "This image is the cover for the book New Day in Babylon"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("New Day in Babylon\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The most comprehensive account available of the rise and fall of the Black Power Movement and of its dramatic transformation of both African-American and larger American culture. With a gift for storytelling and an ear for street talk, William Van Deburg chronicles a decade of deep change, from the armed struggles of the Black Panther party to the cultural nationalism of artists and writers creating a new aesthetic. Van Deburg contends that although its tactical gains were sometimes short-lived, the Black Power movement did succeed in making a revolution—one in culture and consciousness—that has changed the context of race in America."), _c('br'), _c('br'), _vm._v(" \""), _c('i', [_vm._v("New Day in Babylon")]), _vm._v(" is an extremely intelligent synthesis, a densely textured evocation of one of American history's most revolutionary transformations in ethnic group consciousness.\"—Bob Blauner, "), _c('i', [_vm._v("New York Times")]), _c('br'), _c('br'), _vm._v(" Winner of the Gustavus Myers Center Outstanding Book Award, 1993")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      William L. Van Deburg\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Please fill in author biography")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The University of Chicago Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0